module.exports = __webpack_public_path__ + "static/media/sea.0198b711.jpg";